import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    IDraftApplication,
    IDraftApplicationListResponse,
    IRawDraftSearchResult,
    RawDraftSearchResult,
} from "../../types/installerInterface/installerApplicationTypes"

export const installerDraftsMapper = {
    /**
     * Maps the response from the installer drafts API to the IDraftApplication interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IDraftApplication.
     */
    mapSingle: (response: unknown): IDraftApplication => {
        const res = tsIoValidate<IRawDraftSearchResult>(
            RawDraftSearchResult,
            response,
            "Error mapping installer draft applications"
        )
        if (res.Items.length === 0) {
            throw invalidApiDataError("No installer drafts found.")
        }

        const draft = { ...res.Items[0] }
        return {
            ...draft,
        }
    },

    /**
     * Maps `getInstallerDrafts` response confirming valid data.
     * @param response - The response from the API.
     * @returns The mapped object of type IDraftApplicationListResponse.
     *
     * */
    mapList: (response: unknown): IDraftApplicationListResponse => {
        const res = tsIoValidate<IRawDraftSearchResult>(
            RawDraftSearchResult,
            response,
            "Error mapping installer list drafts"
        )

        return {
            totalResults: res.Count,
            pageSizes: res.ScannedCount,
            data: res.Items,
            nextPageKey: res.LastEvaluatedKey,
        }
    },
}
